import { CategoryName, StyledHorizontalLine } from "./styles";

interface CategoryDividerProps {
  categoryName: string;
  className?: string;
}

const CategoryDivider = ({
  categoryName,
  className = "",
}: CategoryDividerProps) => {
  return (
    <div className={`flex items-center justify-center mb-2 ${className}`}>
      <CategoryName className="category-divider-title">
        {categoryName}
      </CategoryName>
      <div className="grow category-divider-line ml-4">
        <StyledHorizontalLine />
      </div>
    </div>
  );
};

export default CategoryDivider;
